export default __webpack_public_path__ + "static/media/480_dummy-2014-store01-mobile-de.1a8e06bd.png";